import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './MultiSelectRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "overflowContainer", staticClass: "multiselect overflow-container" },
    [
      _vm._l(_vm.visibleValues, function(value, i) {
        return _c(
          "span",
          {
            key: i,
            ref: "tag",
            refInFor: true,
            staticClass: "tag",
            attrs: { title: value }
          },
          [_vm._v("\n        " + _vm._s(value) + "\n    ")]
        )
      }),
      _vm._v(" "),
      _vm.hiddenValues.length > 0
        ? _c(
            "Button",
            {
              ref: "target",
              attrs: { spacing: "none", "is-selected": _vm.isOpen },
              on: { click: _vm.toggleDropdown }
            },
            [_vm._v("\n        +" + _vm._s(_vm.hiddenValues.length) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "Popper",
            {
              ref: "popper",
              attrs: {
                "target-element": _vm.$refs.target.$el,
                offset: "0,5",
                placement: "bottom-end"
              }
            },
            [
              _c(
                "div",
                { ref: "dropdown", staticClass: "dropdown-list" },
                _vm._l(_vm.hiddenValues, function(value, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "item", attrs: { title: value } },
                    [
                      _vm._v(
                        "\n                " + _vm._s(value) + "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-360f0406";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/MultiSelectRenderer.vue.js